export const FETCH_MENU_DATA = {
  START: 'START_FETCH_MENU_DATA',
  COMPLETE: 'COMPLETE_FETCH_MENU_DATA',
  FAIL: 'FAIL_FETCH_MENU_DATA',
}

export const CLEANUP_MENU_DATA = 'CLEANUP_MENU_DATA'
